export default "__VITE_ASSET__c5102107__"